module.exports = __webpack_public_path__ + "img/energy003.a72012d0.png";